import { FC } from "react";
import { Field, FieldProps } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import { IFieldProps } from "..";
import { FeedbackMessage } from "src/UI";
import { CustomerItemType } from "src/Types";
import { ParticipantSelect } from "src/Controls";

interface IParticipantProps extends IFieldProps {};

const Participant: FC<IParticipantProps> = ( props ) => {

	const { name, title, isRequired, setData } = props;

	const onChangeHandler = ( value: string | null, form: any ): any => {
		form.setFieldTouched(name, true);
		form.setFieldValue(name, value);
		!!setData && setData((data: any) => {
			return { ...data, [name]: value }
		});
	};

	const renderInnerField = ( formProps: FieldProps ) => {
		const { form, meta, field } = formProps;
		
		return (
			<FormGroup>
				{
					!!title &&
					<Label htmlFor={name}>
						<b className={isRequired ? 'field_asterix' : ''}>
							{title}
						</b>
					</Label>
				}
				<ParticipantSelect 
					value={field.value} 
					setValue={ (v?: CustomerItemType) => onChangeHandler(v?.id || null, form)} 
				/>
				{(meta.error && meta.touched) && <FeedbackMessage message={meta.error} /> }
			</FormGroup>
		);
	};

	return (
		<Field id={name} name={name}>
			{ renderInnerField }
		</Field>
	);
};

export default Participant;
